if (!window.InteractiveImage) {
  /**
   * Interactive Image Hotspots JS
   */
  class InteractiveImage {
    constructor(container) {

      this.container = container;
      this.hotspots = container.querySelectorAll('[data-hotspot]');
      this.init();
    }

    init() {
      // Click interaction for triggers
      this.container.querySelectorAll('.ii-hotspot-trigger').forEach(trigger => {
        trigger.addEventListener('click', (e) => {
          if (window.innerWidth > 768) return; // Ignore click on desktop

          e.stopPropagation();
          e.preventDefault(); // Prevent accidental form submits or jumps

          this.toggleHotspot(trigger.closest('[data-hotspot]')); 
        });
      });

      // Close buttons (Mobile)
      this.container.querySelectorAll('.ii-close-mobile').forEach(btn => {
        btn.addEventListener('click', (e) => {
          e.stopPropagation();
          e.preventDefault();
          this.closeAll();
        });
      });

      // Hover interaction (Optional, for desktop)
      this.hotspots.forEach(hotspot => {
        hotspot.addEventListener('mouseenter', () => {
          if (window.innerWidth > 768) {
            this.openHotspot(hotspot);
          }
        });

        hotspot.addEventListener('mouseleave', () => {
          if (window.innerWidth > 768) {
            this.closeHotspot(hotspot);
          }
        });
      });

      // Close on outside click
      document.addEventListener('click', (e) => {
        // Only close if click is OUTSIDE the container or on the overlay
        if (!this.container.contains(e.target)) {
           this.closeAll();
        }
      });
    }

    toggleHotspot(hotspot) {
      const isActive = hotspot.classList.contains('is-active');
      this.closeAll();
      if (!isActive) {
        this.openHotspot(hotspot);
      }
    }

    openHotspot(hotspot) {
      hotspot.classList.add('is-active');
      this.container.classList.add('has-active'); 
      if (window.innerWidth <= 768) {
        document.body.classList.add('ii-open');
      }
    }

    closeHotspot(hotspot) {
      hotspot.classList.remove('is-active');
      // Verifica se tem mais algum ativo antes de remover do pai
      if (!this.container.querySelector('.ii-hotspot.is-active')) {
        this.container.classList.remove('has-active');
      }
      if (window.innerWidth <= 768) {
        document.body.classList.remove('ii-open');
      }
    }

    closeAll() {
      this.hotspots.forEach(hotspot => {
        this.closeHotspot(hotspot);
      });
      this.container.classList.remove('has-active'); 
      document.body.classList.remove('ii-open');
    }
  }

  window.InteractiveImage = InteractiveImage; // Expose to window
}

// Initialize on DOM load (Safeguarded)
function initInteractiveImages() {
  const containers = document.querySelectorAll('[data-interactive-image]');

  containers.forEach(container => {
    // Avoid double initialization
    if (!container.dataset.iiInitialized) {
      new window.InteractiveImage(container);
      container.dataset.iiInitialized = 'true';
    }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initInteractiveImages);
} else {
  initInteractiveImages();
}
